<!-- Boton + panel flotante (navbar) -->
<div class="selector-tema selector-tema--menu" *ngIf="vista === 'menu'">
  <button
    type="button"
    class="selector-tema__boton"
    (click)="alternar()"
    [attr.aria-expanded]="abierto()"
    aria-haspopup="true"
    aria-label="Cambiar estilo visual"
    title="Estilo visual: {{ estiloActual.nombre }} · {{ modoActual.nombre }}"
  >
    <i class="material-icons">{{ modoActual.icono }}</i>
  </button>

  <div class="selector-tema__panel" *ngIf="abierto()" role="menu">
    <div class="selector-tema__titulo">Estilo visual</div>

    <ng-container *ngTemplateOutlet="segmentado; context: { $implicit: true }"></ng-container>

    <button
      type="button"
      class="selector-tema__opcion"
      *ngFor="let estilo of estilos"
      [class.is-actual]="esEstiloActual(estilo.id)"
      (click)="elegirEstilo(estilo.id)"
      role="menuitemradio"
      [attr.aria-checked]="esEstiloActual(estilo.id)"
    >
      <ng-container *ngTemplateOutlet="miniatura; context: { $implicit: muestra(estilo) }"></ng-container>
      <span class="selector-tema__texto">
        <strong>{{ estilo.nombre }}</strong>
        <span>{{ estilo.descripcion }}</span>
      </span>
      <i class="material-icons selector-tema__check" aria-hidden="true">check_circle</i>
    </button>
  </div>
</div>

<!-- Modo + tarjetas desplegadas (ajustes) -->
<div class="selector-tema selector-tema--tarjetas" *ngIf="vista === 'tarjetas'">
  <div class="selector-tema__grupo">
    <span class="selector-tema__etiqueta" id="selector-tema-modo">Modo</span>
    <ng-container *ngTemplateOutlet="segmentado; context: { $implicit: false }"></ng-container>
    <span class="selector-tema__ayuda">{{ ayudaModo }}</span>
  </div>

  <div class="selector-tema__grupo">
    <span class="selector-tema__etiqueta" id="selector-tema-estilo">Estilo</span>
    <div class="selector-tema__rejilla" role="radiogroup" aria-labelledby="selector-tema-estilo">
      <button
        type="button"
        class="selector-tema__tarjeta"
        *ngFor="let estilo of estilos"
        [class.is-actual]="esEstiloActual(estilo.id)"
        (click)="elegirEstilo(estilo.id)"
        role="radio"
        [attr.aria-checked]="esEstiloActual(estilo.id)"
      >
        <ng-container *ngTemplateOutlet="miniatura; context: { $implicit: muestra(estilo), grande: true }"></ng-container>
        <span class="selector-tema__texto">
          <strong>
            <i class="material-icons">{{ estilo.icono }}</i>
            {{ estilo.nombre }}
          </strong>
          <span>{{ estilo.descripcion }}</span>
        </span>
        <span class="selector-tema__estado">{{ esEstiloActual(estilo.id) ? 'En uso' : 'Usar' }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Control segmentado de modo: claro / oscuro / automatico -->
<ng-template #segmentado let-compacto>
  <fieldset
    class="selector-tema__modos"
    [class.selector-tema__modos--compacto]="compacto"
    [attr.aria-labelledby]="compacto ? null : 'selector-tema-modo'"
    [attr.aria-label]="compacto ? 'Modo' : null"
  >
    <button
      type="button"
      class="selector-tema__modo"
      *ngFor="let modo of modos"
      [class.is-actual]="esModoActual(modo.id)"
      (click)="elegirModo(modo.id)"
      [attr.aria-pressed]="esModoActual(modo.id)"
    >
      <i class="material-icons" aria-hidden="true">{{ modo.icono }}</i>
      <span>{{ modo.nombre }}</span>
    </button>
  </fieldset>
</ng-template>

<!-- Miniatura: una pantallita dibujada con los colores del estilo -->
<ng-template #miniatura let-m let-grande="grande">
  <span
    class="selector-tema__mini"
    [class.selector-tema__mini--grande]="grande"
    [style.background]="m.fondo"
    aria-hidden="true"
  >
    <span class="selector-tema__mini-barra" [style.background]="m.barra">
      <span [style.background]="m.acento"></span>
    </span>
    <span class="selector-tema__mini-cuerpo">
      <span class="selector-tema__mini-tarjeta" [style.background]="m.superficie">
        <span [style.background]="m.texto"></span>
        <span [style.background]="m.texto"></span>
      </span>
      <span class="selector-tema__mini-tarjeta" [style.background]="m.superficie">
        <span [style.background]="m.acento"></span>
      </span>
    </span>
  </span>
</ng-template>
